module.exports = __webpack_public_path__ + "img/06b-osm-emissao-avulsa.99d2df76.png";